export const UnderlineIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" fill="none" viewBox="0 0 12 20" className="fill-black dark:fill-white">
            <path d="M10.848 0a.909.909 0 00-.909.91v9.696A3.945 3.945 0 016 14.546a3.945 3.945 0 01-3.939-3.94V.909a.91.91 0 10-1.818 0v9.697a5.758 5.758 0 0011.515 0V.909A.91.91 0 0010.848 0zM10.848 18.182H1.151a.909.909 0 100 1.818h9.697a.91.91 0 000-1.818z"></path>
        </svg>
    );
};
